import { render, staticRenderFns } from "./AddAdvertisement.vue?vue&type=template&id=74a658c2&scoped=true&"
import script from "./AddAdvertisement.vue?vue&type=script&lang=js&"
export * from "./AddAdvertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a658c2",
  null
  
)

export default component.exports